import React, {Fragment, useCallback, useEffect, useRef, useState} from 'react'

import './exchange-kb.scss'
import {DateRangePicker, Message, Pagination, Radio, ShowItemsSelect} from "../utilites";
import {useDispatch, useSelector} from "react-redux";
import {contractStatuses, kbStatus, kbTypes, listRoles, pageOptions} from "../../helpers/data-constants";
import {Link} from "react-router-dom";
import Loader from "./Loader";
import {getMessages} from "../../redux/actions/kbExchangeActions";
import moment from "moment";
import _cloneDeep from "lodash/cloneDeep";
import Arrow from '../../assets/icons/arrow-down.svg';
import KBMessageDetails from "./Details/KBMessageDetails";
import Select, {components} from "react-select";
import {getDepartments, getDepartmentsTab, resetAllOptions} from "../../redux/actions/handbookAction";
import {getUserFromLocalStorage, permissionsAccess} from "../../helpers/common";
import {authService} from "../../services/auth-service";
import Warning from "../../assets/icons/warning.svg";
import CheckMark from "../../assets/icons/check-mark.svg";
import {getDealNumber, getFullNameDeal} from "../../redux/actions/clientsAction";
import CrossSmallIcon from "../../assets/icons/cross-small.svg";

const searchStatuses = [
  contractStatuses.ACTIVE.param,
  contractStatuses.EXPIRED.param,
  contractStatuses.TOTRANSFER.param,
  contractStatuses.GOHRAN.param,
  contractStatuses.STORE.param,
  contractStatuses.INVENTORY.param,
  contractStatuses.WITHDRAWAL.param,
  contractStatuses.SALED_GOHRAN.param,
  contractStatuses.SALED_STORE.param,
  contractStatuses.CANCELED.param,
  contractStatuses.UNNECESSARY.param,
  contractStatuses.CLOSED.param
]

const initialEvents = []
const initialStatuses = []

for (const [key, value] of Object.entries(kbTypes)) {
  if (key !== "UNKNOWN") {
    initialEvents.push({
      value: key,
      label: value
    });
  }
}
for (const [key, value] of Object.entries(kbStatus)) {
  initialStatuses.push({
    value: key,
    label: value.text
  });
}

const ExchangeKB = ({setTitlePage}) => {
  const dataActiveCashbox = useRef(authService.getActiveCashBoxId());

  const [state, setState] = useState({
    events: [],
    statuses: [],
    dealNumber: [],
    fullName: [],
    cashboxIds: [dataActiveCashbox.current],
    timeRange: {
      startDate: null,
      endDate: null
    },
    processed: null,
    currentPage: 1,
    pageRange: pageOptions[0].value
  });

  const [messages, setMessages] = useState([]);
  const {departments, loading: loadingCashBox, commonError, clients, dealsNumber} = useSelector(({handbook}) => handbook);
  const {isLoading, commonError: commonErrorKB, messages: kbMessages, totalElements} = useSelector(({kb}) => kb);
  const dispatch = useDispatch();

  const { accessFeatures, isLoadingConfiguration } = useSelector(({user}) => user);
  const showAllDepartments = permissionsAccess("action.cashbox.typeahead");
  const userInfo = getUserFromLocalStorage();
  const goodsSpecialist = userInfo.roles.length === 1 && userInfo.roles.includes(listRoles.GOODS_SPECIALIST);
  const departmentRef = useRef(null);
  const fullNameRef = useRef(null);
  const dealNumberRef = useRef(null);
  const statusRef = useRef(null);
  const eventsRef = useRef(null);

  const handleGetAction = (e, action) => {
    const {name} = action
    if (action.action === 'input-change' && name === 'department') {
      const data = {
        name: e,
        restrictionRole: !showAllDepartments,
        status: searchStatuses.join(','),
        searchType: 'KB'
      }
      if (state.dealNumber && state.dealNumber.length > 0) {
        data.dealIds = state.dealNumber.map(i => i.value).join(',')
      }
      if (state.fullName && state.fullName.length > 0) {
        data.clientIds = state.fullName.map(i => i.value).join(',')
      }
      dispatch(getDepartmentsTab(data))
    }
    if (action.action === 'input-change' && name === 'fullName') {
      const data = {
        size: 5,
        page: 1,
        sortBy: 'fullName',
        name: e,
        filters: {
          status: searchStatuses.join(','),
        },
      }
      if (state.cashboxIds && state.cashboxIds.length > 0) {
        data.filters.cashBoxIds = state.cashboxIds.map(i => i.value).join(',')
      }
      if (state.dealNumber && state.dealNumber.length > 0) {
        data.filters.dealIds = state.dealNumber.map(i => i.value).join(',')
      }
      dispatch(getFullNameDeal(data));
    }
    if (action.action === 'input-change' && name === 'dealNum') {
      const data = {
        size: 10,
        page: 1,
        filters: {
          status: searchStatuses.join(','),
          searchType: 'KB'
        },
        descending: false,
        sortBy: 'dealNumber',
        number: e
      }
      if (state.timeRange.endDate) {
        data.filters.kbEndDate = state.timeRange.endDate
      }
      if (state.timeRange.startDate) {
        data.filters.kbStartDate = state.timeRange.startDate
      }
      if (state.events && state.events.length > 0) {
        data.filters.kbEvent = state.events.map(i => i.value).join(',')
      }
      if (state.statuses && state.statuses.length > 0) {
        data.filters.kbStatus = state.statuses.map(i => i.value).join(',')
      }
      if (state.cashboxIds && state.cashboxIds.length > 0) {
        data.filters.cashBoxIds = state.cashboxIds.map(i => i.value).join(',')
      }
      if (state.fullName && state.fullName.length > 0) {
        data.filters.clientIds = state.fullName.map(i => i.value).join(',')
      }
      dispatch(getDealNumber(data))
    }
  };

  useEffect(() => {
    accessFeatures['title.header_section'] && setTitlePage('Обмен с Кредитным Бюро');
  }, [isLoadingConfiguration]);

  useEffect(() => {
    dispatch(getDepartments("", !showAllDepartments))
  }, [dispatch])

  useEffect(() => {
    if (kbMessages) {
      setMessages(kbMessages);
    }
  }, [kbMessages]);

  const loadMessages = () => {
    const data = {
      size: state.pageRange,
      page: state.currentPage,
      descending: true,
      filters: {}
    };

    if (state.cashboxIds && state.cashboxIds.length > 0) {
      data.filters.cashBoxId = state.cashboxIds.map(c => c.value).join(",");
    }
    if (state.dealNumber && state.dealNumber.length > 0) {
      data.filters.dealId = state.dealNumber.map(c => c.value).join(",");
    }
    if (state.fullName && state.fullName.length > 0) {
      data.filters.clientIds = state.fullName.map(c => c.value).join(",")
    }
    if (state.statuses && state.statuses.length > 0) {
      data.filters.status = state.statuses.map(c => c.value).join(",");
    }
    if (state.events && state.events.length > 0) {
      data.filters.event = state.events.map(c => c.value).join(",");
    }
    if (state.processed !== null) {
      data.filters.processed = state.processed
    }
    if (state.timeRange) {
      if (state.timeRange.startDate) {
        data.filters.startDate = state.timeRange.startDate.format("yyyy-MM-DD")
      }
      if (state.timeRange.endDate) {
        data.filters.endDate = state.timeRange.endDate.format("yyyy-MM-DD")
      }
    }
    dispatch(getMessages(data));
  }

  useEffect(() => {
    loadMessages();
  }, [
    state.pageRange,
    state.currentPage,
    state.cashboxIds,
    state.events,
    state.statuses,
    state.timeRange,
    state.processed,
    dispatch,
    state.fullName,
    state.dealNumber
  ]);

  const changeVisible = (id) => {
    let ind = messages.findIndex((item) => item.id === id);
    let newArray = _cloneDeep(messages);
    newArray[ind].isVisible = !messages[ind].isVisible;
    setMessages(newArray);
  };

  const onTimeRangeChange = (timeRange) => {
    setState((prev) => ({
      ...prev,
      timeRange: timeRange,
      currentPage: 1
    }));
  }

  const onPageRangeChange = useCallback(({target: {value}}) => {
    setState((prev) => ({
      ...prev,
      pageRange: parseInt(value),
      currentPage: 1,
    }));
  }, []);

  const handlePageChange = useCallback((page) => {
    setState((prev) => ({
      ...prev,
      currentPage: page,
    }));
  }, []);

  const chooseDepartments = (department) => {
    if (department && Array.isArray(state.cashboxIds)) {
      if (!state.cashboxIds.find(({value}) => value === department.value)) {
        const newArrDepartments = [...state.cashboxIds];
        newArrDepartments.push(department);

        setState((prev) => ({
          ...prev,
          cashboxIds: newArrDepartments,
          currentPage: 1
        }));
        dispatch(resetAllOptions())
      }
    }
  };

  const chooseEvent = (event) => {
    if (event && Array.isArray(state.events)) {
      if (!state.events.find(({value}) => value === event.value)) {
        const newEvents = [...state.events];
        newEvents.push(event);

        setState((prev) => ({
          ...prev,
          events: newEvents,
          currentPage: 1
        }));
      }
    }
  };

  const deleteCashBoxChoice = (value, action) => {
    let filteredArrDepartments = [];
    let filteredArrFullName = [];
    let filteredArrDealsNumber = [];
    if (!goodsSpecialist) {
      filteredArrDepartments = state.cashboxIds.filter((i) => i.value !== value);
      setState((prev) => ({
        ...prev,
        cashboxIds: filteredArrDepartments,
        currentPage: 1
      }));
    }
    if (action === 'fullName') {
      filteredArrFullName = state.fullName.filter((i) => i.value !== value);
      setState((prev) => ({
        ...prev,
        fullName: filteredArrFullName,
        currentPage: 1
      }));
    }
    if (action === 'dealNumber') {
      filteredArrDealsNumber = state.dealNumber.filter(el => el.value !== value);
      setState((prev) => ({
        ...prev,
        dealNumber: filteredArrDealsNumber,
        currentPage: 1
      }));
    }
  };

  const renderCashBoxes = (facet) => {
    return (
        facet.length !== 0 &&
        facet.map((i) => {
          return (
              <button
                  type="button"
                  className="search-facet"
                  key={i.value}
                  onClick={() => deleteCashBoxChoice(i.value, i.action)}
                  id="button">
              <span htmlFor="button" className={'not-crossed'}>
                {i.label}
              </span>
              </button>
          );
        })
    );
  };

  const deleteEventChoice = (value) => {
    const filteredArr = state.events.filter((i) => i.value !== value);

    setState((prev) => ({
      ...prev,
      events: filteredArr,
      currentPage: 1
    }));
  };

  const renderEvents = () => {
    return (
        state.events.length !== 0 &&
        state.events.map((i) => {
          return (
              <button
                  type="button"
                  className="search-facet"
                  key={i.value}
                  onClick={() => deleteEventChoice(i.value)}
                  id="button">
            <span htmlFor="button" className={'not-crossed'}>
              {i.label}
            </span>
              </button>
          );
        })
    );
  };

  const chooseStatus = (status) => {
    if (status && Array.isArray(state.statuses)) {
      if (!state.statuses.find(({value}) => value === status.value)) {
        const newStatuses = [...state.statuses];
        newStatuses.push(status);

        setState((prev) => ({
          ...prev,
          statuses: newStatuses,
          currentPage: 1
        }));
      }
    }
  };

  const chooseFullName = (name) => {
    if (name && Array.isArray(state.fullName)) {
      if (!state.fullName.find(({value}) => value === name.value)) {
        const newArrFullName = [...state.fullName]
        newArrFullName.push(name)

        setState({
          ...state,
          fullName: newArrFullName,
          currentPage: 1
        });
        dispatch(resetAllOptions())
      }
    }
  }

  const chooseDealsNumber = (number) => {
    if (number && Array.isArray(state.dealNumber)) {
      if (!state.dealNumber.find(({value}) => value === number.value)) {
        const newDealNumber = [...state.dealNumber]
        newDealNumber.push(number)

        setState({
          ...state,
          dealNumber: newDealNumber,
          currentPage: 1
        });
        dispatch(resetAllOptions())
      }
    }
  }


  const deleteStatusChoice = (value) => {
    const filteredArr = state.statuses.filter((i) => i.value !== value);

    setState((prev) => ({
      ...prev,
      statuses: filteredArr,
      currentPage: 1
    }));
  };

  const renderStatuses = () => {
    return (
        state.statuses.length !== 0 &&
        state.statuses.map((i) => {
          return (
              <button
                  type="button"
                  className="search-facet"
                  key={i.value}
                  onClick={() => deleteStatusChoice(i.value)}
                  id="button">
            <span htmlFor="button" className={'not-crossed'}>
              {i.label}
            </span>
              </button>
          );
        })
    );
  };

  const onReload = () => {
    loadMessages()
  }

  const handleProcessedChanged = (event) => {
    let result = null;
    const target = event?.target;
    const id = target.id;

    switch (id) {
      case 'processed':
        result = true;
        break;
      case 'toProcess':
        result = false;
        break;
      default:
        break;
    }

    setState((prev) => ({
      ...prev,
      processed: result,
      currentPage: 1
    }));
  };

  const handleReset = () => {
    setState((prev) => ({
      ...prev,
      cashboxIds: [dataActiveCashbox.current],
      fullName: [],
      dealNumber: [],
      events: [],
      statuses: [],
      currentPage: 1,
      timeRange: {
        startDate: null,
        endDate: null
      },
    }));

    departmentRef.current.select.clearValue();
    fullNameRef.current.select.clearValue();
    dealNumberRef.current.select.clearValue();
    eventsRef.current.select.clearValue();
    statusRef.current.select.clearValue();
  };

  const Placeholder = props => <components.Placeholder {...props} />
  return (<main className="app-content">
    { isLoadingConfiguration ?
      (<div className="content-inner">
        <Loader pageRange={1}/>
      </div>) :
      (<>
        { !accessFeatures['title.header_section'] &&
          (<div className="content-header">
            <h1>Обмен с Кредитным Бюро</h1>
          </div>
        )}
        <div className="content-inner">
          <div className="content-inner-data exchange-inner-data">
            <div className="exchange-content">
              <div className="d-flex flex-column align-center m-l-auto m-r-auto">
                <div className="content-datatable-header-center">
                  <div className="action-items">
                    <div className="content-datatable-header-search">
                      <Select
                        ref={departmentRef}
                        classNamePrefix="select"
                        className="basic-multi-select"
                        placeholder="Введите подразделение"
                        isLoading={loadingCashBox}
                        options={departments}
                        noOptionsMessage={() => 'Нет результатов'}
                        loadingMessage={() => 'Загрузка...'}
                        onInputChange={(value, action) =>
                          handleGetAction(value, { ...action, name: 'department' })
                        }
                        onChange={chooseDepartments}
                      />
                    </div>
                    {accessFeatures['kb.search'] && <div className="content-datatable-header-search">
                      <Select
                        ref={dealNumberRef}
                        classNamePrefix="select"
                        className="basic-multi-select"
                        placeholder="Введите номер договора"
                        isLoading={loadingCashBox}
                        options={dealsNumber}
                        noOptionsMessage={() => 'Нет результатов'}
                        loadingMessage={() => 'Загрузка...'}
                        onInputChange={(value, action) =>
                          handleGetAction(value, {...action, name: 'dealNum'})
                        }
                        onChange={chooseDealsNumber}
                      />
                    </div>}
                    {accessFeatures['kb.search'] &&  <div className="content-datatable-header-search">
                      <Select
                        ref={fullNameRef}
                        classNamePrefix="select"
                        className="basic-multi-select"
                        placeholder="Введите ФИО"
                        isLoading={loadingCashBox}
                        options={clients}
                        noOptionsMessage={() => 'Нет результатов'}
                        loadingMessage={() => 'Загрузка...'}
                        onInputChange={(value, action) =>
                          handleGetAction(value, {...action, name: 'fullName'})
                        }
                        onChange={chooseFullName}
                      />
                    </div>}
                  </div>
                </div>
                <div className="content-datatable-header-fullwidth exchange-lowItemSearch">
                  <div className="action-items">
                    <div className="form-row">
                      <div className="form-row-item">
                        <div className="form-element">
                          <div className="form-element-data combobox">
                            <Select
                              ref={eventsRef}
                              options={initialEvents}
                              components={{Placeholder}}
                              classNamePrefix="select"
                              className="basic-multi-select "
                              noOptionsMessage={() => 'Нет результатов'}
                              placeholder="Описание"
                              onChange={chooseEvent}/>
                          </div>
                        </div>
                      </div>
                      <div className="form-row-item">
                        <div className="form-element">
                          <div className="form-element-data combobox">
                            <Select
                              ref={statusRef}
                              options={initialStatuses}
                              components={{Placeholder}}
                              classNamePrefix="select"
                              className="basic-multi-select "
                              noOptionsMessage={() => 'Нет результатов'}
                              placeholder="Статус"
                              onChange={chooseStatus}/>
                          </div>
                        </div>
                      </div>
                      <div className="form-row-item">
                        <DateRangePicker
                          coverClass={'form-element'}
                          startDate={state.timeRange.startDate}
                          endDate={state.timeRange.endDate}
                          onChange={(v) => onTimeRangeChange(v)}/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="content-datatable-header-fullwidth">
                <div className="exchange-searchFacetsKB">
                  {
                    state.cashboxIds.length ?
                      <div className="search-facets-pillboxes exchange-searchItem">
                        <h4 className="exchange-titleFacets">Подразделение:</h4> {renderCashBoxes(state.cashboxIds)}
                      </div> : null
                  }
                  {
                    state.dealNumber.length ?
                      <div className="search-facets-pillboxes exchange-searchItem">
                        <h4 className="exchange-titleFacets">Номер договора:</h4> {renderCashBoxes(state.dealNumber)}
                      </div> : null
                  }
                  {
                    state.fullName.length ?
                      <div className="search-facets-pillboxes exchange-searchItem">
                        <h4 className="exchange-titleFacets">ФИО клиента:</h4> {renderCashBoxes(state.fullName)}
                      </div> : null
                  }
                  {
                    state.events.length ?
                      <div className="search-facets-pillboxes exchange-searchItem">
                        <h4 className="exchange-titleFacets">Описание:</h4> {renderEvents()}
                      </div> : null
                  }
                  {
                    state.statuses.length ?
                      <div className="search-facets-pillboxes exchange-searchItem">
                        <h4 className="exchange-titleFacets">Статус:</h4> {renderStatuses()}
                      </div> : null
                  }
                  <div className="search-facets-actions exchange-resetAll">
                    <button className="button-icontrigger noborder" onClick={handleReset}>
                      <span className="icon">
                        <CrossSmallIcon/>
                      </span>
                      <span>Сбросить</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="content-inner-data-container">
              {commonError && <Message type="error" text={commonError}/>}
              <div className="content-datatable">
                <div className="content-datatable-header ">
                  <div className="content-datatable-header-left  buttongroup-content">
                    <div className="action-items">
                      <div className="pillbox-radiogroup" onChange={handleProcessedChanged}>
                        <Radio
                          pillboxStyle={true}
                          label="Все"
                          id="all"
                          name="radioProcessedSwitcher"
                          checked={true}
                        />
                        <Radio
                          pillboxStyle={true}
                          label="Обработанные"
                          id="processed"
                          name="radioProcessedSwitcher"
                        />
                        <Radio
                          pillboxStyle={true}
                          label="Необработанные"
                          id="toProcess"
                          name="radioProcessedSwitcher"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="content-datatable-header-right">
                    <ShowItemsSelect
                      options={pageOptions}
                      change={onPageRangeChange}
                      wrapClass={'padding-select'}
                    />
                  </div>
                </div>
                <div className="content-datatable-content">
                  {isLoading ? (
                    <Loader pageRange={state.pageRange}/>
                  ) : (
                    <table className="table hover exchange-table">
                      <thead>
                      <tr>
                        <th scope="col"/>
                        <th scope="col">
                          <p>Договор</p>
                        </th>
                        <th scope="col">
                          <p>Время</p>
                        </th>
                        <th scope="col">
                          <p>Клиент</p>
                        </th>
                        <th scope="col">
                          <p>Описание</p>
                        </th>
                        <th scope="col">
                          <p>Код</p>
                        </th>
                        <th scope="col">
                          <p>Статус</p>
                        </th>
                        <th scope="col"/>
                        <th scope="col"/>
                      </tr>
                      </thead>
                      <tbody>
                      {messages && messages.length > 0 && messages.map((message) => {
                        return (
                          <Fragment key={message.id}>
                            <tr>
                              <td>
                            <span className={"icon " + (message.processed ? "icon-green" : "icon-yellow")}>
                            {message.processed ? <CheckMark/> : <Warning/>}
                            </span>
                              </td>
                              <td>
                                <div className="table-cellcontent">

                                  <p>{message.dealId !== -1 &&
                                    <Link
                                      className="table-link"
                                      to={`client/${message.clientId}/contracts/${message.dealId}`}>
                                      <span>{message.dealNumber}</span>
                                    </Link>}

                                  </p>
                                </div>
                              </td>
                              <td>
                                <div className="table-cellcontent">
                                  <p>{moment(message.time).format('DD.MM.YYYY, HH:mm:ss')}</p>
                                </div>
                              </td>
                              <td>
                                <div className="table-cellcontent">
                                  <Link
                                    className="table-link"
                                    to={`client/${message.clientId}`}>
                                    {
                                      message?.client &&
                                      <span>
                                      {message.client.lastName + (message.client.firstName ? ' ' + message.client.firstName : '') + (message.client.middleName ? ' ' + message.client.middleName: '')}
                                    </span>
                                    }
                                  </Link>
                                </div>
                              </td>
                              <td>
                                <p>{kbTypes[message.type || "UNKNOWN"] || kbTypes["UNKNOWN"]}</p>
                              </td>
                              <td>
                                <p>{message.code}</p>
                              </td>
                              <td>
                                <span className="caption">Статус</span>
                                <p><span
                                  className={"label " + kbStatus[message.status].label}>{kbStatus[message.status].text}</span>
                                </p>
                              </td>
                              <td
                                className={`exchange-table-col-arrow${
                                  message.isVisible ? '-up' : ''
                                }`}>
                                <Arrow onClick={() => changeVisible(message.id)}/>
                              </td>
                            </tr>
                            <tr
                              className={`exchange-table-line${
                                message.isVisible ? '-visible' : ''
                              }`}>
                              {message.isVisible &&
                                <KBMessageDetails onReload={onReload} messageId={message.id} dealId={message.dealId}/>}
                            </tr>
                          </Fragment>
                        );
                      })}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
              <Pagination
                total={Math.ceil(totalElements / state.pageRange)}
                current={state.currentPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </>)
    }
  </main>)
}

export default ExchangeKB
